export function randomString(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  if (result.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{6,}$/) !== null) return result;else return randomString(length);
}